import { Grid, Typography } from '@mui/material';

import { FileBrowserHeaderContainer } from '@components/FileBrowser/StyledComponents';

export const FileBrowserTableHeader = () => (
  <FileBrowserHeaderContainer container>
    <Grid item xs={12} sm={4}>
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
        }}
      >
        Name
      </Typography>
    </Grid>
    <Grid item sm={4} display={{ xs: 'none', sm: 'block' }}>
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
        }}
      >
        Created
      </Typography>
    </Grid>
    <Grid item sm={2} display={{ xs: 'none', sm: 'block' }}>
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
        }}
      >
        Size
      </Typography>
    </Grid>
    <Grid item sm={2} display={{ xs: 'none', sm: 'block' }}>
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
        }}
      >
        Actions
      </Typography>
    </Grid>
  </FileBrowserHeaderContainer>
);
